import { useParams, Outlet } from '@tanstack/react-router';
import AsyncPageContainer from '_/common/components/layout/AsyncPageContainer';
import CollectionSection from '_/common/components/layout/CollectionSection';
import { useCollection } from '_/contexts/CollectionContext';
import DocumentTitle from '_/hooks/DocumentTitle';
import React, { ReactElement } from 'react';

function SelectedCollectionContent(): ReactElement {
  const params = useParams({ strict: false }) as Partial<{ collectionSlug: string }>;
  const collectionSlug = params.collectionSlug || '';
  const { selectedCollection, isLoading: isFetchingCollection } = useCollection();

  // Don't render anything for special route slugs - they're handled by other components
  if (collectionSlug === '_new') {
    return <></>;
  }

  DocumentTitle(`${selectedCollection?.name} :: ${location.pathname.split('/').pop()}`);

  return (
    <AsyncPageContainer isLoading={!selectedCollection || isFetchingCollection}>
      <Outlet />
    </AsyncPageContainer>
  );
}

function SelectedCollection(): ReactElement {
  return (
    <CollectionSection>
      <SelectedCollectionContent />
    </CollectionSection>
  );
}

export default SelectedCollection;
